import React, { Component } from 'react';
import { Layout, Menu, Icon, PageHeader, Divider, Tag } from 'antd';
import ComplexMenu from '../../components/complex_menu';
import { main_menu_list } from '..';
import SideMenu from '../../components/side_menu';
import { Switch } from 'react-router-dom';
import { Route ,Redirect} from 'react-router-dom';
import MyTask from './my_task';
import TodayPage from './today';
import { getBreadcrumb } from '../../util/ui_util';
import AllPending from './pending_task';
import DashboardTabPage from './dashboard_tab_page';
import MainLayout from '../main_layout';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { AlarmOutlined, ScheduleOutlined, ReorderOutlined } from '@material-ui/icons';

const { Header, Content, Footer, Sider } = Layout;
const routes = [{
    type:'secondary',
    title:'Recent 1',
    url:'dashboard/main'
},
{
    type:'secondary',
    title:'Recent 2',
    url:'dashboard/main'
},
{
    type:'secondary',
    title:'Recent 3',
    url:'dashboard/main'
}];

const main_menu=[
    {
        type:'loading'
    },
]
const main_menu_2=[
    // {
    //     type:'expandable',
    //     title:"My Task",
    //     defaultExpanded:true,
    //     icon:<ReorderOutlined className='menu-icon'/>,
    //     childItem:[
            {
                type:'main',
                url:'dashboard/today',
                key:'today',
                title:'Today',
                icon:<ScheduleOutlined className='menu-icon'/>
            },
            {
                type:'main',
                url:'dashboard/pending',
                key:'pending',
                title:'All Pending',
                icon:<AlarmOutlined className='menu-icon'/>
            }
            
    //     ]

    // },
]
const side_menu_org=[
    {
        type:'loading'
    },
    {
        type:'expandable',
        title:"My Task",
        defaultExpanded:true,
        icon:<ScheduleOutlined className='menu-icon'/>,
        childItem:[
            {
                type:'main',
                url:'dashboard/today',
                key:'today',
                title:'Today',
                icon:<ScheduleOutlined className='menu-icon'/>
            },
            {
                type:'main',
                url:'dashboard/pending',
                key:'pending',
                title:'All Pending',
                icon:<AlarmOutlined className='menu-icon'/>
            }
            
        ]

    },
]

class DashboardPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            side_items:[...main_menu,...main_menu_2]
        };

        // this.state.side_items.splice(0,1)
        // console.log(this.state.side_items)

        this.list_tab_items=RESTExecutor.list().config({
            label:'tab_list'
        }).callbacks((success)=>{
            let items=[];
            success.result.rows.map((item)=>{
                items.push({
                    type:'secondary',
                    url:`dashboard/${item.id}`,
                    key_position:2,
                    title:item.name,
                    key:item.id
                })
            });
            let prev_list=[...main_menu,...main_menu_2]
            prev_list.splice(0,1)
            let new_list=items.concat(prev_list);
            this.setState({side_items:new_list});
        },(error)=>{
            let items=[{
                type:'error',
                onReload:()=>{
                    this.setState({
                        side_items:[...main_menu,...main_menu_2]
                    },()=>{
                        this.list_tab_items.execute()
                    });

                }
            }]
            let prev_list=[...main_menu,...main_menu_2];
            prev_list.splice(0,1);
            // console.log("prev list",prev_list)
            let new_list=items.concat(prev_list);
            this.setState({side_items:new_list});

        }).connect(props.domains.dashboard);

        this.list_tab_items.execute()
    };

    render() {
        const {side_items}=this.state;
        var pathName=this.props.location.pathname+this.props.location.search;
        // console.log("top",pathName, this.props.location.search)


        return(
            <MainLayout 
            onRef={(ref) => {
                // console.log("changing reg", ref);
                window.slider_main = ref
            }}
            sliderContent={
                <SideMenu
                menuKey={pathName}
                item={side_items}
                />
            }
            pageTitle={"Dashboard"}
            pageRoutes={{routes:getBreadcrumb(this.props.location.pathname)}}
            mainContent={<div style={{
                // paddingTop:16
            }}><Switch>
                    <Route path='/dashboard/pending' component={AllPending}/>
                    <Route path='/dashboard/today' component={TodayPage}/>
                    <Route path='/dashboard/:tab_id' component={DashboardTabPage}/>

                    <Redirect from='/dashboard' to='/dashboard/today' />
                </Switch></div>}
            />
        );
    }
}

export default withDomains(DashboardPage,"dashboard");
